export function SiteFooter() {
  return (
    <footer className="site-footer">
      <a className="footer-brand" href="#top">ALEXADS</a>
      <span>Создаём ясность для роста · © 2026</span>
    </footer>
  );
}
